import { render } from "./CourtDecisionCard.vue?vue&type=template&id=f2389a50&scoped=true"
import script from "./CourtDecisionCard.vue?vue&type=script&lang=js"
export * from "./CourtDecisionCard.vue?vue&type=script&lang=js"

import "./CourtDecisionCard.vue?vue&type=style&index=0&id=f2389a50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2389a50"]])

export default __exports__